<div class="notifications-container position-relative">
    <div class="flex-centered-vr-space-between-container padding">
        <span class="font-bold font-16">Notifications</span>
        <span role="button" tabindex="0" class="decoration-underline font-12 cursor-pointer outline"
            (keydown.enter)="markAllAsRead(notificationType.All)" (click)="markAllAsRead(notificationType.All)">
            Mark all as read
        </span>
    </div>

    <mat-tab-group color="accent" class="notifications-tabs" #tabGroup (selectedTabChange)="onMatTabChange($event)"
        [selectedIndex]="selectedTab" *ngIf="isBacktestAllowed; else noBacktest">

        <!-- Offers Tab -->
        <mat-tab>
            <ng-template mat-tab-label>
                {{notificationType.Offers}} &nbsp;
                <!-- <span class="chamfer fg-white pad-4-hr" *ngIf="offersCount > 0"
                        [ngClass]="selectedTab === 0? 'bg-primary': 'bg-primary-dark'">
                        {{ offersCount }}
                    </span> -->
            </ng-template>
            <ng-template matTabContent>
                <!-- <app-notification-card *ngIf="showPlanExtendedOffer" [type]="notificationType.Offers"
                        [showPlanExtendedOffer]="showPlanExtendedOffer"
                        [free_plan_extension_days]="free_plan_extension_days">
                    </app-notification-card> -->
                <app-notification-card *ngIf="showDiyUpdateNotification" [type]="notificationType.Offers"
                    [showDiyUpdateNotification]="showDiyUpdateNotification">
                </app-notification-card>
            </ng-template>
        </mat-tab>

        <!-- Trades Tab -->
        <mat-tab>
            <ng-template mat-tab-label class="font-12">
                {{notificationType.Trades}} &nbsp;
                <span class="chamfer fg-white pad-4-hr" *ngIf="tradesCount > 0"
                    [ngClass]="selectedTab === 0? 'bg-primary': 'bg-primary-dark'">
                    {{ tradesCount }}
                </span>
            </ng-template>
            <ng-template matTabContent>
                <div class="overlay-loader"
                    *ngIf="viewLoader && selectedTab === notificationTabs.indexOf(notificationType.Trades); else tradesNotificationsTemplate">
                    <mat-spinner></mat-spinner>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Backtest Tab -->
        <mat-tab>
            <ng-template mat-tab-label>
                {{notificationType.Backtest}} &nbsp;
                <span class="chamfer fg-white pad-4-hr" *ngIf="backtestCount > 0"
                    [ngClass]="selectedTab === 0? 'bg-primary': 'bg-primary-dark'">
                    {{ backtestCount }}
                </span>
            </ng-template>
            <ng-template matTabContent>
                <div class="overlay-loader"
                    *ngIf="viewLoader && selectedTab === notificationTabs.indexOf(notificationType.Backtest); else backtestNotificationsTemplate">
                    <mat-spinner></mat-spinner>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

<ng-template #tradesNotificationsTemplate>
    <app-notification-card [type]="notificationType.Trades"></app-notification-card>
</ng-template>

<ng-template #backtestNotificationsTemplate>
    <app-notification-card [type]="notificationType.Backtest"></app-notification-card>
</ng-template>

<ng-template #noBacktest>
    <mat-tab-group class="invisible-tabs notifications-tabs">
        <mat-tab #tabGroup>
            <ng-template matTabContent>
                <div class="overlay-loader" *ngIf="viewLoader; else tradesNotificationsTemplate">
                    <mat-spinner></mat-spinner>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</ng-template>